import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.e.two,
    face.m.one,
    face.e.two,
    face.m.pri,
  ],
  name: 'Dots',
};
